import React, {createContext} from "react";
import { CognitoUser, AuthenticationDetails } from "amazon-cognito-identity-js"
import Pool from "../UserPool";
import { useNavigate, Navigate} from 'react-router-dom';
import { useCallback } from "react";
export const AccountContext = createContext();

export const Account = (props) => {
    let navigate = useNavigate();
    const getSession = async () => {
        const user = Pool.getCurrentUser();
        if(user) {
            return await new Promise((resolve,reject) => {
                const user = Pool.getCurrentUser();
                if(user) {
                    user.getSession(async (err,session)=>{
                        if(err) {
                            reject();
                        } else {
                            const attributes = await new Promise((resolve, reject) => {
                                user.getUserAttributes((err, attributes) => {
                                    if (err) {
                                        reject(err)
                                    }
                                    else {
                                        const results = {};
                                        for (let attribute of attributes) {
                                            const { Name, Value } = attribute;
                                            results[Name] = Value;
                                        }
                                        resolve(results)
                                    }
                                });
                            });
                            resolve({
                                user,
                                ...session,
                                ...attributes
                            });
                            sessionStorage.setItem("userProfile", JSON.stringify(session.idToken.payload));
                            sessionStorage.setItem("customerID", JSON.stringify(session.user))
                            sessionStorage.setItem("idToken", JSON.stringify(session.idToken));
                            sessionStorage.setItem("accessToken", JSON.stringify(session.accessToken));
                        }
                    });
    
                } else {
                    reject();
                    navigate("/login");
                }
            })
        }
      ;
    };
    const forgotPassword = async (Username, Code, NewPassword) => {
        return await new Promise((resolve,reject) => {
            const user = new CognitoUser({
                Username,
                Pool
            });
            user.forgotPassword({
                onSuccess: function(result) {
                    console.log('call result' + result)
                    resolve(result);
                },
                onFailure:function(err) {
                    console.log(err)
                    reject(err);
                },
                inputVerificationCode:(data)=> {
                    sessionStorage.setItem("username", Username)
                    resolve(data);
                }
            })
        })
    }

    const confirmPassword = async (Username, Code, NewPassword) => {
        return await new Promise((resolve,reject) => {
            const user = new CognitoUser({
                Username,
                Pool
            });
            user.confirmPassword(Code,NewPassword, {
                onFailure(err) {
                    reject(err);
                },
                onSuccess() {
                    resolve();
                },
            })
        })
    }
    const authenticate = async (Username, Password) => {
        return await new Promise((resolve,reject) => {
            const user = new CognitoUser({
                Username,
                Pool
            });
    
            const authDetails = new AuthenticationDetails({
                Username,
                Password
            });
    
            user.authenticateUser(authDetails, {
                onSuccess:(data)=> {
                    console.log("onSuccess: ", data)
                    sessionStorage.setItem("isAuth", true);
                    sessionStorage.setItem("userProfile", JSON.stringify(data.idToken.payload));
                    sessionStorage.setItem("customerID", JSON.stringify(data.user))
                    sessionStorage.setItem("idToken", JSON.stringify(data.idToken));
                    sessionStorage.setItem("accessToken", JSON.stringify(data.accessToken));

                    resolve(data);
                },
                onFailure:(err)=> {
                    sessionStorage.setItem("isAuth", false);
                    reject(err);
                },
                newPasswordRequired:(data)=> {
                    console.log("newPasswordRequired: ", data)
                    navigate("/SetNewPassword")
                }
            })
        });
        
    };

    const logout = () => {
        const user = Pool.getCurrentUser();
        if(user) {
            user.signOut();
            navigate("/login");
        }
    };

    return (
        <AccountContext.Provider value={{ authenticate, getSession, logout, forgotPassword, confirmPassword }}>
            {props.children}
        </AccountContext.Provider>
    );
};
